module.exports = __webpack_public_path__ + "media/images/ringrevenue/icon_delete-3cb1d5a0ff51df651c91a3b22cb8473c.png";